import { Injectable } from '@angular/core';
import { AbstractDialogService } from '@examdojo/core/dialog';
import { RemoveAccessConfirmationDialogComponent } from './remove-access-confirmation.component';

@Injectable()
export class RemoveAccessConfirmationDialogService extends AbstractDialogService<void, boolean> {
  readonly id = 'remove-access-confirmation-dialog';
  protected override readonly component = RemoveAccessConfirmationDialogComponent;
}
